import AppDataService from '../../service/AppDataService';

const initialState = {
    showAlert: false,
    alertMessage: null,
    alertType: null,
    alertDuration: 2500,
    users: [],
    cancelTokens: [],
    drawer: true,
};

export default {
    namespaced: true,
    state: {...initialState},
    actions: {
        showSnackbar({commit, state}, payload) {
            const {bool, message, type} = payload;
            commit('setAlert', {bool, message, type});
            setTimeout(() => {
                commit('setAlert', {bool: false, message: null, type: null});
            }, state.alertDuration + 100);
        },
        async fetchAppSettings({commit}) {
            const resp = await AppDataService.get();
            if (resp.status === 200) {
                const {probes, users} = resp.data;
                commit('probe/setProbes', probes, {root: true});
                commit('setUsers', users);
            }
        },
        cancelPendingRequests({commit, state}, url = null) {
            state.cancelTokens.forEach((request) => {
                if (url && request.url === url && request.cancel) request.cancel();
                if (request.cancel && !url) {
                    request.cancel();
                }
            });
            commit('clearCancelToken');
        },
    },
    mutations: {
        setAlert(state, payload) {
            const {bool, message, type} = payload;
            state.showAlert = bool;
            state.alertMessage = message;
            state.alertType = type;
        },
        setUsers(state, users) {
            state.users = users;
        },
        addCancelToken(state, token) {
            state.cancelTokens.push(token);
        },
        clearCancelToken(state) {
            state.cancelTokens = [];
        },
        toggleDrawer(state) {
            state.drawer = !state.drawer;
        },
    },
    getters: {
        noAdminUsers: (state) => {
            return state.users.filter(user => !['admin', 'super_admin'].includes(user.role));
        },
    },
};